import React from 'react';

import { Divider, Typography } from '@material-ui/core';
import { esGestiona, IconAvisoInfo } from '@portal/arq-portal-core';
import { makeStyles } from '@material-ui/core';
import { EnlacePersonal } from './EnlacePersonal';

interface Props {
    items: any[];
}

const useEstilos = makeStyles(() => ({
    iconoInfo:{
        marginBottom:'6px',
        color: '#606060',
    },
    textoInfo:{
        fontSize: '12px',
        color: '#606060',
    }
}));

export const EnlacesPersonales = ({items}: Props) => {
    const clases = useEstilos();
    return (
        <React.Fragment>
            {items.length > 0 ?
                items.map((item: any) => (
                        esGestiona()?<EnlacePersonal item={item} key={item.Url} />  : 
                        <React.Fragment>
                            <EnlacePersonal item={item} key={item.Url} /> 
                            <Divider></Divider>
                        </React.Fragment>
                    )
                ) :
                <div style={{backgroundColor: "#F4F4F4", margin: "14px", textAlign: "center", padding: "20px 15px"}}>
                    <IconAvisoInfo className={clases.iconoInfo} />
                    <Typography className={clases.textoInfo}  variant="caption" component="div">Incluye aquí web externas que te sean de utilidad</Typography>
                </div>
            }
        </React.Fragment>
    )
}